import { getDisciplines } from '../../lib/category/disciplines';
import type { ExerciseItemSchema } from '@/types/schema';
import { NomadDB } from '~/db/NomadDB.js';

export const getExerciseItemsService = (db: NomadDB) => {
  const get = async (params: any): Promise<ExerciseItemSchema> => {
    return await db.exerciseItems.get(params);
  };

  const findByIdsAndLibraryBookId = async (
    ids: string[],
    libraryBookId: string
  ): Promise<ExerciseItemSchema[]> => {
    const req = ids.map((id) => [id, libraryBookId]);

    const items = await db.exerciseItems
      .where(['id+libraryBookId'])
      .anyOf(req)
      .toArray();

    return items;
  };

  const findItemsForDailyQuiz = async (
    ids: string[],
    libraryBookId: string,
    disciplineIds: string[]
  ): Promise<ExerciseItemSchema[]> => {
    const averageTimeSpentMax = 15;
    const successRateMin = 70;
    const selectedItemsCountMax = 10;

    const req = ids.map((id) => [id, libraryBookId, '']);

    const items = await db.exerciseItems
      .where(['id+libraryBookId+statementId'])
      .anyOf(req)
      .and((item) => item.averageTimeSpent < averageTimeSpentMax)
      .reverse()
      .sortBy('successRate');

    const mSelectedItemsByDisciplines = items.reduce((mItems, item) => {
      if (item.successRate > successRateMin) {
        const parent = item.parents.find((parent) => {
          return disciplineIds.includes(parent.disciplineId);
        });
        if (parent) {
          if (!mItems.has(parent.disciplineId)) {
            mItems.set(parent.disciplineId, []);
          }
          mItems.get(parent.disciplineId).push(item);
        }
      }
      return mItems;
    }, new Map());

    console.info(
      'discipline found',
      Array.from(mSelectedItemsByDisciplines.keys()).length
    );
    // shuffle items
    Array.from(mSelectedItemsByDisciplines.keys()).forEach((key) => {
      const items = mSelectedItemsByDisciplines.get(key);
      mSelectedItemsByDisciplines.set(key, shuffleArray(items));
    });

    const getDisciplineIds = () => {
      return Array.from(mSelectedItemsByDisciplines.keys()).reduce(
        (disciplineIds, disciplineId) => {
          if (mSelectedItemsByDisciplines.get(disciplineId).length > 0) {
            disciplineIds.push(disciplineId);
          }
          return disciplineIds;
        },
        []
      );
    };

    let disciplinesPool = getDisciplineIds();
    const selectedItems = [];

    console.info('discipline pool', disciplinesPool.length);
    if (disciplinesPool.length === 0) return [];

    do {
      disciplinesPool = shuffleArray(disciplinesPool);
      const disciplineId = disciplinesPool.shift();

      selectedItems.push(mSelectedItemsByDisciplines.get(disciplineId).shift());

      disciplinesPool =
        disciplinesPool.length === 0 ? getDisciplineIds() : disciplinesPool;
    } while (
      disciplinesPool.length > 0 &&
      selectedItems.length < selectedItemsCountMax
    );

    return selectedItems;
  };

  return {
    get,
    findByIdsAndLibraryBookId,
    findItemsForDailyQuiz,
  };
};
